import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "language",
  legacy: {
    data: "language",
    count: "count",
    fetch: "fetchLanguages",
    create: "createOneLanguage",
    update: "updateLanguage",
    remove: "deleteLanguage",
    updateState: "updateLanguageState",
  },
});

export const LanguageProvider = Provider;
export const useLanguageContext = useValue;
